import { useEffect } from "react";
import { useHistory } from "react-router-dom";

/**
 * useBlockBackNavigation — for order-success / receipt screens.
 *
 * After an order is placed, the browser Back button must NOT return the
 * customer into the checkout/confirm flow: those screens hold stale
 * cart/quote state and re-submitting them is how double orders happen.
 * (The confirm screens also navigate here with history.replace and have
 * empty-cart guards — this hook is the belt to that braces.)
 *
 * Intercepts POP (Back/Forward) navigations and redirects to `redirectTo`
 * (default "/") via replace, so the checkout entries effectively fall out
 * of the customer's forward path. In-app pushes (e.g. Continue Shopping)
 * are unaffected.
 */
export default function useBlockBackNavigation(redirectTo = "/") {
  const history = useHistory();

  useEffect(() => {
    const unblock = history.block((location, action) => {
      if (action === "POP") {
        unblock();
        history.replace(redirectTo);
        return false; // cancel the back navigation itself
      }
      return undefined; // allow pushes/replaces initiated by the app
    });
    return unblock;
  }, [history, redirectTo]);
}
